<template>
  <b-rating :icons="parent_icons" :score="parent_rating" class="mr-2" v-if="parent_count > 0"></b-rating>
</template>

<script>
import Rating from './rating.vue'

export default {
  components: {
    'b-rating': Rating
  },

  computed: {
    google_rating: function() {
      if(this.match.google_place && this.match.google_place.reviews) {
        return { score: this.match.google_place.rating, count: this.match.google_place.reviews.length } || { score: 0, count: 0 }
      }
      return { score: 0, count: 0 }
    },

    parent_rating: function() {
      return (((this.google_rating.score * this.google_rating.count) + (this.yelp_rating.score * this.yelp_rating.count)) / (this.google_rating.count + this.yelp_rating.count)).toFixed(1)
    },

    parent_count: function() {
      return this.google_rating.count + this.yelp_rating.count
    },

    parent_icons: function() {
      var icons = []
      if(this.google_rating.count > 0) { icons.push(this.$assets.icons.google) }
      if(this.yelp_rating.count > 0) { icons.push(this.$assets.icons.yelp) }
      return icons
    },

    yelp_rating: function() {
      if(this.match.yelp_business) {
        return { score: this.match.yelp_business.rating, count: this.match.yelp_business.review_count } || { score: 0, count: 0 }
      }
      return { score: 0, count: 0 }
    },
  },

  props: ['match']
}
</script>
